<template>
    <div>
        <div class="text-[1.5rem] text-primary text-center py-4">
            CamFrom4 金融機構轉帳
        </div>
        <div class="w-full max-w-[24rem] md:max-w-[29rem] mx-auto">
            <InputTypes
                v-model:value="id"
                type="text"
                :maxlength="10"
                label="帳號"
            />
        </div>
        <div class="flex justify-center pt-2">
            <button
                class="btn w-full rounded-full gradient-primary border-0 max-w-[8.75rem]"
                @click.prevent="postApi"
            >
                確定
            </button>
        </div>
        <Loading :isLoading="isLoading" />
    </div>
</template>

<script>
import { reactive, toRefs, inject } from 'vue';
import { postSSOInput } from '@/apis/ssoInput';
import InputTypes from '@/components/inputs/InputTypes.vue';

export default {
    components: {
        InputTypes,
    },
    setup() {
        const $vfm = inject('$vfm');
        const users = reactive({
            id: '',
            aplCatl: '720',
            sysAuthCode: '',
            transactionItemNo: '',
            policyNo: '',
            policySeq: '',
            idDup: '',
            srceFrom: '',
            action: 'change',
            noErrorMsg: '',
            source: 'SCV',
            isLoading: false,
        });

        const postApi = async (canPost) => {
            if (canPost) {
                users.isLoading = true;
                const path = process.env.VUE_APP_API_PATH;
                const baseUrl = `${window.location.origin}${path}`;
                const data = {
                    id: users.id,
                    aplCatl: users.aplCatl,
                    source: users.source,
                    sysAuthCode: users.sysAuthCode,
                    transactionItemNo: users.transactionItemNo,
                    policyNo: users.policyNo,
                    policySeq: users.policySeq,
                    idDup: users.idDup,
                    srceFrom: users.srceFrom,
                    action: users.action,
                    a4: null,
                    a5: null
                };
                postSSOInput(data).then(res => {
                    window.location.href = `${baseUrl}/ssoLogin?param=${res.data.token}`;
                }).catch(err => {
                    openPopup(err.data?.errorMessage);
                }).finally(() => {
                    users.isLoading = false;
                });
            }
        };

        const openPopup = (errorMessage) => {
            $vfm.show({
                component: 'DialogBase',
                params: {
                    title: '系統提示',
                    content: errorMessage || '系統忙碌中，請稍後再試',
                    confirmButton: '確認',
                    cancelButton: null,
                    closeicon: true,
                },
                on: {
                    confirm() {
                        $vfm.hide('DialogBase');
                    },
                    closed() {
                        $vfm.hide('DialogBase');
                    },
                }
            });
        };

        return {
            ...toRefs(users),
            postApi
        };
    },
};
</script>
